import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-merge-profile-error-modal',
  templateUrl: './merge-profile-error-modal.component.html',
  styleUrls: ['./merge-profile-error-modal.component.scss'],
  standalone: false
})
export class MergeProfileErrorModalComponent {
  constructor(
    public dialogRef: MatDialogRef<MergeProfileErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {}
}
